import React from 'react';
import {FieldViewProps} from "../../../render/view";
import Reminder from "../../../../model2/reminder/reminer";

export default function FieldReminder_View(props:FieldViewProps) {

    const reminder = _.get(props.model, props.field.fieldId, null) as Reminder

    if (!reminder) return null

    const classes = Classes("flex-row-left-center ", "", props.className, {
    })

    return (
        <div className={classes}>
            <div className="ui5-ico-14 i5-notification m-r-5"/>
            <span className="ui5-txt-default txt-truncate no-wrap">{reminder.title}</span>
        </div>
    );
}
